import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { GestorRepository } from '@app/domain/ports/tpv/gestor.repository';
import {
  GestorAssignResult,
  GestorServicesResult,
  GestorUpdateResult,
} from '@app/domain/models/tpv/gestor.model';
import {
  AssignGestorRequest,
  GestorAssignResponseDto,
  GestorServicesResponseDto,
  GestorUpdateResponseDto,
  UpdateGestorRequest,
} from '@app/data/dtos/tpv/gestor.dto';
import {
  mapGestorAssignResult,
  mapGestorServicesResult,
  mapGestorUpdateResult,
} from '@app/data/mappers/tpv/gestor.mapper';
import { toHttpParams } from '@app/data/data-sources/remote/tpv/tpv-http.util';

/**
 * Gestores genéricos (`/api/gestor/*`). A diferencia del resto del TPV, estos
 * endpoints viven en el API PRINCIPAL (`environment.apiUrl`), no en el micro
 * (`tpvApiUrl`), y usan auth `IsAdminUser`. El Bearer lo añaden los interceptores.
 */
@Injectable()
export class GestorRemoteDataSource extends GestorRepository {
  private readonly http = inject(HttpClient);

  /** `${apiUrl}/api/gestor/<path>` sin `/` duplicados. */
  private url(path: string): string {
    const root = (environment.apiUrl ?? '').replace(/\/+$/, '');
    return `${root}/api/gestor/${path.replace(/^\/+/, '')}`;
  }

  override assign(request: AssignGestorRequest): Observable<GestorAssignResult> {
    return this.http
      .post<GestorAssignResponseDto>(this.url('assign/'), request)
      .pipe(map(mapGestorAssignResult));
  }

  override listServices(
    polipayAccount: string,
    includeInactive = false,
  ): Observable<GestorServicesResult> {
    return this.http
      .get<GestorServicesResponseDto>(this.url('services/'), {
        params: toHttpParams({
          polipay_account: polipayAccount,
          include_inactive: includeInactive,
        }),
      })
      .pipe(map(mapGestorServicesResult));
  }

  override update(request: UpdateGestorRequest): Observable<GestorUpdateResult> {
    return this.http
      .put<GestorUpdateResponseDto>(this.url('update/'), request)
      .pipe(map(mapGestorUpdateResult));
  }
}
